import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
import VisibilityIcon from '@mui/icons-material/Visibility';

interface PermissionBadgeProps {
  accessLevel: string;
  size?: 'small' | 'medium';
}

export const PermissionBadge: React.FC<PermissionBadgeProps> = ({ 
  accessLevel, 
  size = 'small' 
}) => {
  const getPermissionConfig = () => {
    switch (accessLevel?.toLowerCase()) {
      case 'administrator':
      case 'admin':
        return {
          label: 'Administrador',
          color: 'error' as const,
          icon: <AdminPanelSettingsIcon fontSize="small" />,
          tooltip: 'Você é administrador deste board e pode gerenciar tudo'
        };
      case 'member':
        return {
          label: 'Membro',
          color: 'primary' as const,
          icon: <PersonIcon fontSize="small" />,
          tooltip: 'Você é membro deste board e pode editar cartões'
        };
      case 'observer':
      default:
        return {
          label: 'Observador',
          color: 'default' as const,
          icon: <VisibilityIcon fontSize="small" />,
          tooltip: 'Você é observador deste board e pode apenas visualizar'
        };
    }
  };

  const config = getPermissionConfig();

  return (
    <Tooltip title={config.tooltip} arrow>
      <Chip
        label={config.label}
        color={config.color}
        size={size}
        icon={config.icon}
        variant="outlined"
        sx={{
          borderWidth: 2,
          fontWeight: 500,
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          '& .MuiChip-icon': {
            marginLeft: '8px'
          }
        }}
      />
    </Tooltip>
  );
};
